import {
    AccessDevicesTitle,
    IconChipDepartment,
    IconChipMultiplePerson, IconDepartmentTitlePlus, IconMonitorTitlePlus,
    IconPersonPlusCard
} from "../../../../../../../components/buttons/IconButtons";
import {permissionObj} from "../../../../../../../Helpers/permission";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 */

/**
 * Resource type identifiers handled by the shift access sections.
 * Each section manages a single resource type (client-side selection).
 */
export const SHIFT_RESOURCE = {
    DEVICES: 'DEVICES',
    DEPARTMENTS: 'DEPARTMENTS',
    USERS: 'USERS'
}

/**
 * Backend "resourceString" selector for the assigned / not-assigned shift
 * resource endpoints. Mirrors the Devices authentication-mode selector: the
 * server uses it to pick the per-mode shape (device | departments | user).
 */
export const SHIFT_RESOURCE_MODE = {
    [SHIFT_RESOURCE.DEVICES]: 'device',
    [SHIFT_RESOURCE.DEPARTMENTS]: 'departments',
    [SHIFT_RESOURCE.USERS]: 'user'
}

export const MODEL_DATA = {
    id: null,
    name: '',
    isValid: function (devices = []) {
        return this.name !== '' && devices.length > 0;
    },
    toRegister: function (devices, departments, user) {
        return {
            id: this.id,
            name: this.name,
            deviceIds: devices.map(item => item.id),
            departmentIds: departments.map(item => item.id),
            userIds: user.map(item => item.userId ?? item.id)
        }
    }
}

export const STEPS_CREATE_SHIFT_ACCESS = {
    ACCESS_DEVICE: {
        INDEX: 0,
        TRANS: "access_device",
    },
    ACCESS_DEPARTMENTS: {
        INDEX: 1,
        TRANS: "access_departments",
    },
    CUSTOM_ACCESS: {
        INDEX: 2,
        TRANS: "custom_access",
    },
    SUMMARY: {
        INDEX: 3,
        TRANS: "summary",
    }
}

export const STEPS_UPDATE_SHIFT_ACCESS = {
    ACCESS_DEVICE: {
        INDEX: 0,
        TRANS: "access_device",
    },
    ACCESS_DEPARTMENTS: {
        INDEX: 1,
        TRANS: "access_departments",
    },
    CUSTOM_ACCESS: {
        INDEX: 2,
        TRANS: "custom_access",
    }
}

/**
 * Builds the inner Add/Assigned tab list for a section.
 *
 * Mirrors Devices: on create (no id) only the Add tab (key 0) is shown; on
 * update (id present) the Assigned tab (key 1) is added too.
 *
 * @param {Object} tabs - Tab config object.
 * @returns {(id: number|string|null|undefined) => Array<Object>} Resolver.
 */
const getTabsById = (tabs) => (id) => {
    const hasId = id !== null && id !== undefined;
    return Object.values(tabs)
        .filter(e => typeof e === 'object' && e.key !== undefined)
        .filter(e => hasId || e.key === 0);
};

export const ACCESS_DEVICES_TABS = {
    ADD_DEVICES: {
        key: 0,
        name: "ADD_DEVICES",
        translation: "add_devices",
        icon: <IconMonitorTitlePlus width={24} height={24}/>,
        permission: permissionObj?.WEB_ATTENDANCE_SHIFT_CREATE,
    },
    ASSIGNED_DEVICES: {
        key: 1,
        name: "ASSIGNED_DEVICES",
        translation: "assigned_devices",
        icon: <AccessDevicesTitle width={24} height={24}/>,
        permission: permissionObj?.WEB_ATTENDANCE_SHIFT_CREATE,
    },
    getTabsById: getTabsById({}),
}
ACCESS_DEVICES_TABS.getTabsById = getTabsById(ACCESS_DEVICES_TABS);

export const ACCESS_DEPARTMENTS_TABS = {
    ADD_DEPARTMENT: {
        key: 0,
        name: "ADD_DEPARTMENT",
        translation: "add_department",
        icon: <IconDepartmentTitlePlus width={24} height={24}/>,
        permission: permissionObj?.WEB_ATTENDANCE_SHIFT_CREATE,
    },
    ASSIGNED_DEPARTMENT: {
        key: 1,
        name: "ASSIGNED_DEPARTMENT",
        translation: "assigned_department",
        icon: <IconChipDepartment width={24} height={24}/>,
        permission: permissionObj?.WEB_ATTENDANCE_SHIFT_CREATE,
    },
    getTabsById: getTabsById({}),
}
ACCESS_DEPARTMENTS_TABS.getTabsById = getTabsById(ACCESS_DEPARTMENTS_TABS);

export const CUSTOM_ACCESS_TABS = {
    ADD_EMPLOYEES: {
        key: 0,
        name: "ADD_EMPLOYEES",
        translation: "add_employees",
        icon: <IconPersonPlusCard width={24} height={24}/>,
        permission: permissionObj?.WEB_ATTENDANCE_SHIFT_CREATE,
    },
    ASSIGNED_EMPLOYEES: {
        key: 1,
        name: "ASSIGNED_EMPLOYEES",
        translation: "assigned_employees",
        icon: <IconChipMultiplePerson width={24} height={24}/>,
        permission: permissionObj?.WEB_ATTENDANCE_SHIFT_CREATE,
    },
    getTabsById: getTabsById({}),
}
CUSTOM_ACCESS_TABS.getTabsById = getTabsById(CUSTOM_ACCESS_TABS);
